(function() {
    'use strict';

    var defaults = {
        closeOnOuterClick: true,
        closeOnNavigate: true,
        closingClass: '.lightbox_close',
        delay: 0,
        focusClass: '',
        openClass: 'open',
        overFullPage: true,
        blockScroll: true,
        evList: [],
    };

    var CONS = {
        animationTime: 100,
    };

    Odigeo.UIElements.Lightbox = function($container, options) {
        this.$container = $container;
        this.opts = _.extend({}, defaults, options);

        if (this.opts.overFullPage) {
            this.attachToMainPage();
        }

        this.bindEvents();
    };

    _.extend(Odigeo.UIElements.Lightbox.prototype, {

        bindEvents: function() {
            this.opts.evList.push({
                name: 'tap',
                selector: this.opts.closingClass,
                handler: 'onTapClosingClass',
            });

            _.each(this.opts.evList, (evObj) => {
                if (!_.isUndefined(evObj.selector)) {
                    this.$container.on(Odigeo.Events[evObj.name], evObj.selector, _.bind(this[evObj.handler], this));
                } else {
                    this.$container.on(evObj.name, _.bind(this[evObj.handler], this));
                }
            });

            if (this.opts.closeOnOuterClick) {
                this.enableCloseOnOuterClick();
            }
            if (this.opts.closeOnNavigate) {
                this.enableCloseOnNavigate();
            }
        },

        toggle: function(isOpen, newDelay) {
            var currentDelay = !_.isUndefined(newDelay) && !_.isNull(newDelay) ? newDelay : this.opts.delay;
            _.delay(_.bind(function() {
                this.$container.toggleClass(this.opts.openClass, isOpen);
                this.setFocus(this.opts.focusClass);
                if (this.opts.blockScroll) {
                    this.toggleMainPageScroll(isOpen);
                }
            }, this), currentDelay);
            this.notify(isOpen ? 'open' : 'close');
        },

        remove: function(newDelay) {
            var currentDelay = !_.isUndefined(newDelay) && !_.isNull(newDelay) ? newDelay : this.opts.delay;
            _.delay(_.bind(function() {
                this.$container.remove();
                if (this.opts.blockScroll) {
                    this.toggleMainPageScroll(false);
                }
            }, this), currentDelay);
            this.notify('remove');
        },

        isOpen: function() {
            return this.$container.hasClass(this.opts.openClass);
        },

        onTapClosingClass: function() {
            this.toggle(false, 0);
        },

        onTrackElement: function(event) {
            var targetData = $(event.target).data();
            Odigeo.trigger('analytics:tracking', {
                type: 'trackEvent',
                data: {
                    page: Odigeo.History.getPageNameFromFragment(),
                    action: targetData.trackaction,
                    label: targetData.tracklabel,
                },
            });
        },

        setFocus: function(targetClass) {
            if (targetClass) {
                _.delay(_.bind(function() {
                    this.$container.find(targetClass).focus();
                }, this), CONS.animationTime);
            }
        },

        enableCloseOnOuterClick: function() {
            this.$container.on(Odigeo.Events.tap, _.bind(function(e) {
                if ($(e.target).is(this.$container)) {
                    this.onTapClosingClass();
                }
            }, this));
        },

        enableCloseOnNavigate: function() {
            this.$container.on('lightbox:closeOnNavigate', _.bind(this.remove, this));
        },

        attachToMainPage: function() {
            this.$container.detach().appendTo(Odigeo.Device.getViewport());
        },

        notify: function(event) {
            this.trigger('lightbox:' + event);
        },

        toggleMainPageScroll: function(isDisabling) {
            Odigeo.Device.getViewport().toggleClass('od-viewport-no-vertical-scroll', isDisabling);
        },

    }, Backbone.Events);
}());
